export const moduleEnabledOrOpenIntercom = (moduleEnabled, successCallback, intercomMessage) => {
  if (moduleEnabled) {
    successCallback();
  } else {
    Intercom(
      'showNewMessage',
      intercomMessage
    );
  }
};